import axios from "axios";
import { database } from "../../config/firebase";

const API_KEY = process.env.REACT_APP_BACKEND_URL;

export const getAuthTokenAndAddUserList = values => dispatch => {
  axios
    .post(`${API_KEY}/auth/addUserList`, {
      addUserList: {
        password: values.password,
        nombre: values.nombre
      }
    })
    .then(res => {
      database
        .ref()
        .child("users")
        .child(res.data.userRecord.uid)
        .set({
          key: res.data.userRecord.uid,
          nombre: res.data.userRecord.displayName,
          nivel: values.nivel,
          identificadorNivel: values.identificadorNivel,
          rut: values.rut,
          password: values.password,
          colegio: values.colegio
        });
    });
};

export const getAuthTokenAndAddUser = (values, setStatus) => dispatch => {
  axios
    .post(`${API_KEY}/auth/addUser`, {
      addUser: {
        password: values.password,
        nombre: values.nombre
      }
    })
    .then(res => {
      database
        .ref()
        .child("users")
        .child(res.data.userRecord.uid)
        .set({
          key: res.data.userRecord.uid,
          nombre: res.data.userRecord.displayName,
          nivel: values.nivel,
          identificadorNivel: values.identificadorNivel,
          rut: values.rut,
          password: values.password,
          colegio: values.colegio
        });
    })
    .then(() => {
      setStatus({ success: true });
    });
};

export const getAuthTokenAndAddProfessor = (values, setStatus) => dispatch => {
  axios
    .post(`${API_KEY}/auth/addProfessor`, {
      addProfessor: {
        password: values.password,
        nombre: values.nombre
      }
    })
    .then(res => {
      database
        .ref()
        .child("users")
        .child(res.data.userRecord.uid)
        .set({
          key: res.data.userRecord.uid,
          nombre: res.data.userRecord.displayName,
          rut: values.rut,
          password: values.password,
          colegio: values.colegio,
          admin: false,
          professor: true
        });
    })
    .then(() => {
      setStatus({ success: true });
    });
};

export const resetPassword = (key, password) => dispatch => {
  axios
    .put(`${API_KEY}/auth/changeUserPassword`, {
      update: {
        uid: key,
        password
      }
    })
    .then(res => {
      database
        .ref()
        .child("users")
        .child(res.data.userRecord.uid)
        .update({
          password
        });
      dispatch({
        type: "CHANGE_USER_PASSWORD",
        payload: { uid: res.data.userRecord.uid, password }
      });
    });
};
